(function () {
  function getShieldMaxGallery() {
    // Best: Liquid marker on the gallery
    let g = document.querySelector('media-gallery[data-shield-max="1"]');
    if (g) return g;

    // Fallback: if marker missing, try by id pattern
    g = document.querySelector('media-gallery[id^="MediaGallery-"]');
    return g || null;
  }

  function getSectionIdFromGallery(gallery) {
    if (!gallery) return null;

    // Prefer your Liquid attribute
    const attr = gallery.getAttribute("data-section-id");
    if (attr) return attr;

    // Fallback: parse from id="MediaGallery-<sectionid>"
    const id = gallery.id || "";
    const m = id.match(/^MediaGallery-(.+)$/);
    return m ? m[1] : null;
  }

  function getSlides(gallery) {
    if (!gallery) return [];
    return Array.from(gallery.querySelectorAll('li[data-media-filename]'));
  }

  function toToken(value) {
    return (value || "")
      .toLowerCase()
      .trim()
      .replace(/[\u2018\u2019\u201C\u201D]/g, "'")
      .replace(/\s+/g, "_")
      .replace(/[^a-z0-9_]/g, "");
  }

  // Extracts exact token like iphone_15_pro_max from filenames or option labels
function extractModelToken(text) {
  const f = (text || "").toLowerCase();
  const match = f.match(/iphone_\d+(?:_pro_max|_pro|_plus|_air)?/);
  return match ? match[0] : null;
}

  function getSelectedVariantFromEmbeddedJSON() {
    const node = document.querySelector('[data-selected-variant]');
    if (!node || !node.textContent) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (e) {
      return null;
    }
  }

  function getSelectedModelLabel() {
    // 1) Most reliable in Dawn when present
    const v = getSelectedVariantFromEmbeddedJSON();
    if (v && v.options && v.options.length) return v.options[0];

    // 2) Radios (pills)
    const checked = document.querySelector("variant-radios input[type='radio'][name^='options[']:checked");
    if (checked && checked.value) return checked.value;

    // 3) Select dropdown
    const select = document.querySelector("variant-selects select[name^='options[']");
    if (select && select.value) return select.value;

    return null;
  }

  function localeOk(filename) {
    const htmlLang = document.documentElement.lang || "";
    const locale = htmlLang.split("-")[0];

    if (!filename) return true;
    const f = filename.toLowerCase();

    if (locale === "ja") return f.includes("_ja") || f.includes("-ja");
    if (locale === "ko") return f.includes("_ko") || f.includes("-ko");

    return !(f.includes("_ja") || f.includes("-ja") || f.includes("_ko") || f.includes("-ko"));
  }

  function showAll(slides) {
    slides.forEach((li) => {
      li.style.display = "";
      li.setAttribute("aria-hidden", "false");
    });
  }

function setFirstVisibleActive(gallery, slides) {
  const visible = slides.filter((li) => li.style.display !== "none");
  if (!visible.length) return;

  const r = gallery.getBoundingClientRect();
  if (r.top < -80) return;

  slides.forEach((li) => li.classList.remove("is-active"));
  visible[0].classList.add("is-active");

  try {
    const mediaId = visible[0].getAttribute("data-media-id");
    if (mediaId && typeof gallery.setActiveMedia === "function") {
      gallery.setActiveMedia(mediaId, true);
    }
  } catch (e) {}
}

  function refreshSlider(sectionId) {
    try {
      const viewer = document.getElementById("GalleryViewer-" + sectionId);
      if (viewer && typeof viewer.resetPages === "function") viewer.resetPages();
      window.dispatchEvent(new Event("resize"));
    } catch (e) {}
  }

 function applyFilter() {
  // Always set debug so it never becomes undefined again
  window.__ShieldMaxFilterDebug = { stage: "start" };

  const gallery = getShieldMaxGallery();
  if (!gallery) {
    window.__ShieldMaxFilterDebug.stage = "no_gallery";
    return;
  }

  const sectionId = getSectionIdFromGallery(gallery);
  const slides = getSlides(gallery);

  window.__ShieldMaxFilterDebug.stage = "gallery_found";
  window.__ShieldMaxFilterDebug.galleryId = gallery.id || null;
  window.__ShieldMaxFilterDebug.sectionId = sectionId;
  window.__ShieldMaxFilterDebug.slideCount = slides.length;

  if (!slides.length) {
    window.__ShieldMaxFilterDebug.stage = "no_slides";
    return;
  }

  // Activation logic:
  // 1) data-shield-max="1" OR
  // 2) filename convention (_iphone_15_, _iphone_16_, _iphone_17_)
  const attr = gallery.getAttribute("data-shield-max");
 const looksLikeShieldMaxByFiles = slides.some(li => {
  const fn = (li.getAttribute("data-media-filename") || "").toLowerCase();
  return /iphone_\d+/.test(fn);
});

  window.__ShieldMaxFilterDebug.stage = "activation_check";
  window.__ShieldMaxFilterDebug.dataShieldMax = attr;
  window.__ShieldMaxFilterDebug.looksLikeShieldMaxByFiles = looksLikeShieldMaxByFiles;

  if (attr !== "1" && !looksLikeShieldMaxByFiles) {
    window.__ShieldMaxFilterDebug.stage = "not_shield_max";
    return;
  }

  const modelLabel = getSelectedModelLabel();
  const selectedToken = extractModelToken(toToken(modelLabel));

  window.__ShieldMaxFilterDebug.stage = "model_detected";
  window.__ShieldMaxFilterDebug.modelLabel = modelLabel;
  window.__ShieldMaxFilterDebug.selectedToken = selectedToken;

  if (!selectedToken) {
    window.__ShieldMaxFilterDebug.stage = "no_selected_token";
    showAll(slides);
    return;
  }

  let matchCount = 0;
  slides.forEach((li) => {
    const filename = (li.getAttribute("data-media-filename") || "").toLowerCase();
    const fileToken = extractModelToken(filename);
    const isMatch = fileToken === selectedToken && localeOk(filename);

    if (isMatch) {
      matchCount += 1;
      li.style.display = "";
      li.setAttribute("aria-hidden", "false");
    } else {
      li.style.display = "none";
      li.setAttribute("aria-hidden", "true");
    }
  });

  window.__ShieldMaxFilterDebug.stage = "filtered";
  window.__ShieldMaxFilterDebug.matchCount = matchCount;

  // Fail-safe: avoid empty gallery
  if (matchCount === 0) {
    window.__ShieldMaxFilterDebug.stage = "match_zero_fail_open";
    showAll(slides);
    return;
  }

  setFirstVisibleActive(gallery, slides);
  if (sectionId) refreshSlider(sectionId);

  window.__ShieldMaxFilterDebug.stage = "done";
}

  function debounce(fn, wait) {
    let t;
    return function () {
      clearTimeout(t);
      t = setTimeout(fn, wait);
    };
  }

  function init() {
    // Expose direct manual trigger for mobile testing
    window.__ShieldMaxFilterApply = applyFilter;
    window.SHIELD_MAX_GALLERY = {
      apply: applyFilter,
      extractFromFilename: extractModelToken
    };

    // Run now + after short delays (mobile hydration)

applyFilter();

const safeApply = () => {
  if (window.scrollY < 300) applyFilter();
};

setTimeout(safeApply, 150);
setTimeout(safeApply, 500);
setTimeout(safeApply, 1200);

    // Events
    document.addEventListener("change", (e) => {
      if (e.target && (e.target.name === "id" || e.target.closest("variant-radios, variant-selects, product-form, product-info"))) {
        requestAnimationFrame(applyFilter);
      }
    });

    

    // Mutation observer for DOM swaps
    const debounced = debounce(applyFilter, 60);
    if (window.MutationObserver) {
      const obs = new MutationObserver(() => debounced());
      const gallery = getShieldMaxGallery();
const productSection = gallery ? gallery.closest('.shopify-section') : null;
const observeTarget = productSection || gallery || document.body;

obs.observe(observeTarget, { childList: true, subtree: true });
    }
  }

  
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();